module.exports = __webpack_public_path__ + "static/media/flower_vase_3.01524e51.png";